import { createFileRoute } from '@tanstack/react-router'
import { AssetDetail } from '@/features/hr-assets'

/**
 * Route shell for one asset's full record (plans/17 Task 10) — the audit path
 * the drawer points at. Route definition and render only; the grant guard
 * lives in `AssetDetail`, which is also where the back navigation belongs.
 */
export const Route = createFileRoute('/_authenticated/hr/assets/$assetId')({
  component: AssetDetailRoute,
})

function AssetDetailRoute() {
  const { assetId } = Route.useParams()
  return <AssetDetail assetId={assetId} />
}
